export default __webpack_public_path__ + "d8a009871c3fb1037844a7e998176a68.wasm";